(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data', {
      controller: 'DataRedirectCtrl',
      template: '<div></div>',
      requiredPermissions: ['admin', 'manager']
    });
  }]).controller('DataRedirectCtrl', ['User', '$location', 'UserRoles', function (User, $location, UserRoles) {
    $location.replace();
    if (UserRoles.isConsultant(User.get())) {
      $location.path("/");
      return;
    }
    $location.path("/data/start");
  }]).controller('DataNavCtrl', ['$scope', 'User', 'UserRoles', 'Analytics', 'DataDropdownLinks', function ($scope, User, UserRoles, Analytics, DataDropdownLinks) {
    var user = User.get();
    $scope.organizationName = user.organization.name;
    $scope.$emit("nav:change", "data");
    $scope.links = DataDropdownLinks.get('data');
    Analytics.dataViewed(_.findWhere($scope.links, {
      section: $scope.section
    }));
  }]);
})();
